import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 16,
    overflow: "hidden",
  },
  dialogHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.5),
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #eef0f3",
  },
  dialogHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  dialogHeaderIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(17, 98, 254, 0.1)",
    color: theme.palette.primary.dark,
  },
  dialogTitleText: {
    fontSize: "1.1rem",
    fontWeight: 700,
    color: "#1f2937",
    lineHeight: 1.2,
  },
  dialogSubtitle: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dialogBody: {
    padding: theme.spacing(2, 2.5, 2.5),
    overflowX: "hidden",
  },
  caseCard: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(1.5),
    // The app has no global CssBaseline, so the card has to opt into
    // border-box itself to keep its padding and border inside the dialog.
    boxSizing: "border-box",
    textAlign: "left",
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1.5),
    borderRadius: 12,
    border: "1px solid #e5e9f0",
    backgroundColor: theme.palette.common.white,
    cursor: "pointer",
    transition: "border-color 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      boxShadow: "0 2px 8px rgba(17, 98, 254, 0.12)",
    },
    "&:last-child": { marginBottom: 0 },
  },
  caseCardCurrent: {
    borderColor: theme.palette.primary.main,
    backgroundColor: "rgba(17, 98, 254, 0.04)",
  },
  caseCardLocked: {
    cursor: "not-allowed",
    "&:hover": {
      borderColor: "#e5e9f0",
      boxShadow: "none",
    },
  },
  caseCardLeft: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  caseCardTopRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  caseNumber: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: theme.palette.primary.dark,
    backgroundColor: "rgba(17, 98, 254, 0.1)",
    padding: "2px 10px",
    borderRadius: 8,
  },
  caseChip: {
    fontSize: "0.7rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    padding: "3px 8px",
    borderRadius: 999,
    backgroundColor: "#eef2ff",
    color: "#4f46e5",
  },
  criticalChip: {
    backgroundColor: "#fdecec",
    color: "#d3302f",
  },
  caseDesc: {
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#1f2937",
    marginTop: theme.spacing(0.75),
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  caseMeta: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  caseCardRight: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: theme.palette.text.secondary,
  },
  lockIcon: {
    fontSize: 18,
    color: theme.palette.text.secondary,
  },
  noCasesText: {
    padding: theme.spacing(3, 0),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  dialogActions: {
    padding: theme.spacing(1.5, 2.5, 2),
  },
  cancelBtn: {
    textTransform: "none",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
}));
